import { SessionServerSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { EntityActionNames, IEntityAction } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { runFlowTaskChangePriority } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { ManageRunFlowTaskActions, userHasManageRunFlowTaskPermissions } from '../utils/FlowTaskActionUtils';

export const RunFlowTaskChangePriorityAction: IEntityAction<RunFlowTaskInfo, ManageRunFlowTaskActions> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: ManageRunFlowTaskActions, targetItems: RunFlowTaskInfo[], state: AppState) => {
    const ignoreExtractTaskPriority: boolean =  SessionServerSelectors.ignoreExtractTaskPriority(state);

    return !ignoreExtractTaskPriority && userHasManageRunFlowTaskPermissions(availableActions);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangePriority(targetItems)
};
